import { render, staticRenderFns } from "./voiceRec.vue?vue&type=template&id=6bc21a88&scoped=true&"
import script from "./voiceRec.vue?vue&type=script&lang=js&"
export * from "./voiceRec.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/resource/voiceRec.less?vue&type=style&index=0&id=6bc21a88&lang=less&scoped=true&"
import style1 from "./voiceRec.vue?vue&type=style&index=1&id=6bc21a88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc21a88",
  null
  
)

component.options.__file = "voiceRec.vue"
export default component.exports